module.exports = __webpack_public_path__ + "assets/monitor4.jpg?a29d65dce59b561b764fabea7791ad65";